
import Button from "../General/Button"
import { useDispatch, useSelector } from "react-redux";
import EnquirySuccess from "../Layout/EnquirySuccess";
import Link from "next/link";
import { handleAuthModal } from "../../store/AuthSlice";

function DirectPurchase( {data, api, onBuyButtonClick, showPrice} : any ) {
    const dispatch : any = useDispatch();
	const { enquiryState } = useSelector((state: any) => state.core);

    return (
        <div className="bg-white rounded pb-2 mb-4 px-3 pt-3 md:mb-0 rounded-[5px]" style={{ border: '0.5px solid rgba(170, 170, 170, 0.5)' }}>

            <div className="flex justify-between py-2 px-2 lg:py-2 mb-[7px]">
                <p className="text-[12px] lg:w-[48%] font-[700]"> { data.manufacturer_name ? data.manufacturer_name : '-' } </p>
                <div className="text-[12px]">  
                    { 
                        data.country ?
                        <div className="flex items-center justify-center" >
                            <img className="w-[20px] mr-2" src={data.country.flag_link} alt={data.country.short_name} />
                            <p> { data.country.name } </p>
                        </div>
                        :
                        '-'
                    } 
                </div>
            </div>

            {
                data.certificate_list.length > 0 &&
                <div className="flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[7px]">
                    <p className="text-[14px] lg:w-[48%]">Quality certificates</p>
                    <p className="text-[14px] font-[700]"> 
                        {
                            data.certificate_list.map((certificate : any, index : number) => (
                                <span key={index}>
                                    { certificate.name }{ index === data.certificate_list.length - 1 ? '' : ' / ' }
                                </span>
                            ))  
                        } 
                    </p>
                </div>
            }

            {
                data.pharmacopoeia_grade_list.length > 0 &&
                <div className="flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[6px]">
                    <p className="text-[14px] lg:w-[48%]">Pharmacopeia grades</p>
                    <p className="text-[14px] font-[700]"> 
                        {
                            data.pharmacopoeia_grade_list.map((certificate : any, index : number) => (
                                <span key={index}>
                                    { certificate.name }{ index === data.pharmacopoeia_grade_list.length - 1 ? '' : ' / ' }
                                </span>
                            ))  
                        } 
                    </p>
                </div>
            }

            <div className="flex justify-between items-center mb-[13px]">
                {
                    data.quantity_available &&
                    <div className="flex justify-between flex-col py-2 px-2 lg:py-2 lg:justify-start">
                        <p className="text-[14px] font-[600]"> { data.quantity_available } {data.quantity_available_unit_details.name} </p>
                        <p className="text-[14px] font-light">Stock Available</p>
                    </div>
                }

                {
                    data.shipping_term_details &&
                    <div className="flex justify-between flex-col py-2 px-2 lg:py-2 lg:justify-start text-right">
                        <p className="text-[14px] font-[600]"> {data.shipping_term_details ? data.shipping_term_details.name : '-'} </p>
                        <p className="text-[14px] font-light">Shipping Terms</p>
                    </div>
                }
            </div>

            <div className="px-3 rounded-[3px]" style={{ background: 'rgba(219, 107, 43, 0.15)' }}>
                <div className="flex justify-between py-2 lg:py-2">
                    <p className="text-[16px] lg:w-[48%]">Price ($) </p>
                    <p className={`text-[16px] font-bold ${!data.price && 'blur-[3px]'}`}> ${ data.price ? data.price : 'XX' } </p>
                </div>

                {
                    !showPrice ?
                    <div className="py-2">
                        <Button 
                            styles = "bg-theme-orange text-white px-4" 
                            height = {34} 
                            borderRadius = {3}
                            width = {'100%'}
                            onClick = {() => dispatch(handleAuthModal(true))}
                            > 
                            Login to see Price 
                        </Button>
                    </div>
                    :
                    <div className="flex justify-between py-2">
                        <Button 
                            borderRadius = {3} 
                            width = '48%' 
                            height = {32} 
                            styles = 'bg-[#407BFF] text-white text-[15px]'
                            onClick = {onBuyButtonClick}
                        > 
                            Buy 
                        </Button>

                        <Link
                            href={`${process.env.NEXT_PUBLIC_SELLER_HOME_PAGE_URL}dashboard/fixed-price/create`} 
                            target="_blank"
                            className="block w-[48%]"
                        >
                            <Button 
                                borderRadius = {3} 
                                width = '100%' 
                                height = {32} 
                                styles = 'bg-[#F55246] text-white text-[15px]'> 
                                Sell 
                            </Button>
                        </Link>
                    </div>
                }
            </div>
            

            <EnquirySuccess  
				show = {enquiryState.showSuccessModal} 
				user = {enquiryState.responseData ? enquiryState.responseData.user : '' } />
        </div>
    )
}

export default DirectPurchase